// Animation teams (one per village/chapel) responsible for the Sunday masses.
// Each carries a distinct colour, shown as a stripe on the calendar cards.
export interface Team {
  id: string;
  name: string;
  color: string;
  special?: boolean; // one-off Pardon/feast (shown by name, not in the rotation filter)
}

export const TEAMS: Team[] = [
  { id: "le-boyer", name: "Le Boyer", color: "#2563a8" },
  { id: "le-gretay", name: "Le Gretay", color: "#0f8e8a" },
  { id: "bois-de-la-roche", name: "Bois de la Roche", color: "#5a8a3c" },
  { id: "pont-ruelland", name: "Pont Ruelland", color: "#c47a1e" },
  { id: "mauron-ville", name: "Mauron Ville", color: "#9b4292" },
];

// One-off masses (Pardons/feasts at a specific chapel) — not part of the rotation,
// so kept out of the filter/picker but resolvable for display.
export const SPECIAL_TEAMS: Team[] = [
  { id: "ste-anne-beuves", name: "Ste Anne de Beuves (Pardon)", color: "#9a6a3c", special: true },
  { id: "ste-suzanne", name: "Ste Suzanne", color: "#5f6f8c", special: true },
];

export const DEFAULT_TEAM = "le-boyer";

export function teamById(id?: string): Team | undefined {
  return id ? [...TEAMS, ...SPECIAL_TEAMS].find((t) => t.id === id) : undefined;
}

// How a team reads on a card: rotation teams say "Équipe X"; one-offs show their name.
export function teamLabel(t: Team): string {
  return t.special ? t.name : `Équipe ${t.name}`;
}
